module.exports = __webpack_public_path__ + "static/img/hamzanwadi.d59946c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UniLogo/hamzanwadi.png
// module id = l3/L
// module chunks = 8